const KEY = "wato:chunk-reload-at";
const WINDOW_MS = 30_000;

/** True for the errors a browser throws when a lazy chunk is gone (stale tab after a deploy). */
export function isChunkLoadError(error: unknown): boolean {
  const text = error instanceof Error ? `${error.name} ${error.message}` : String(error ?? "");
  return /ChunkLoadError|Loading chunk [^\s]+ failed|dynamically imported module|Importing a module script failed|error loading dynamically/i.test(
    text,
  );
}

/**
 * Reloads the page once (not again within 30s, so a truly broken deploy cannot loop) to pick up the
 * new build. Returns whether a reload was started.
 */
export function reloadOnceForChunkError(
  storage: Pick<Storage, "getItem" | "setItem"> | null = safeSession(),
  reload: () => void = () => window.location.reload(),
  now: number = Date.now(),
): boolean {
  try {
    const last = Number(storage?.getItem(KEY) ?? 0);
    if (last && now - last < WINDOW_MS) return false;
    storage?.setItem(KEY, String(now));
  } catch {
    return false;
  }
  reload();
  return true;
}

function safeSession(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

/** Vite fires `vite:preloadError` when a lazy import's preload fails: reload to the fresh build. */
export function installChunkReload(): void {
  window.addEventListener("vite:preloadError", (event) => {
    if (reloadOnceForChunkError()) event.preventDefault();
  });
}
